import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'app-compartilhe',
    templateUrl: './compartilhe.component.html',
    styleUrls: ['./compartilhe.component.scss']
})

export class CompartilheComponent implements OnInit {


    ngOnInit(): void {
         
    }

}